import { Button, Row, Col, Typography,Modal,Input,Spin,Upload } from "antd";
import { useState } from "react";
import { BuzzBucketHeader } from "./buzzBucketHeader";
import { BuzzBucketHomePage } from "./buzzBucketHomepage";
import { ChatWindow } from "../chatwindow";
import { ChatModelFetch} from "../../../shared/axios";
import Lottie from "react-lottie";
import ResponseJson from "../../../assets/json/generating response animation.json";
import { v4 as uuid } from "uuid";
// import "./buzzBucket.css";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkParse from "remark-parse";
import mermaid from "mermaid";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import { FaRegCopy } from "react-icons/fa";
import { GithubOutlined, UploadOutlined, PlusOutlined, DeleteOutlined, ArrowRightOutlined, StopOutlined } from '@ant-design/icons';
import { toast } from "react-toastify";


const { Text } = Typography;
const { TextArea } = Input;

export const BuzzBucketBot = () => {
  const [isChatting, setIsChatting] = useState(false);
  const [inputQuestion, setInputQuestion] = useState("");
  const [messages, setMessage] = useState([]);
  const [isTypingStopped, setIsTypingStopped] = useState(false);
  const [isMermaidRendering, setIsMermaidRendering] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isPRModalVisible, setIsPRModalVisible] = useState(false);
  const [repoInputs, setRepoInputs] = useState([{ repoUrl: "", branch: "", username: "", password: "", relevantPath: "" }]);
  const [prDetails, setPRDetails] = useState({ username: '', password: '', prLink: '' });
  const [uploadedFile, setUploadedFile] = useState(null);
  const [disableUpload, setDisableUpload] = useState(false);


  const isGitDetailsEntered = repoInputs.some(input => input.repoUrl !== '');
  const isPRDetailsEntered = prDetails.prLink !== '';
  const isFileUploaded = uploadedFile !== null;

  const uploadProps = {
    beforeUpload: (file) => {
      setUploadedFile(file);
      setDisableUpload(true);
      return false;
    },
    onRemove: () => {
      setUploadedFile(null);
      setDisableUpload(false);
    },
  };

  const handleInputChange = (index, field, value) => {
    const updatedInputs = [...repoInputs];
    updatedInputs[index][field] = value;
    setRepoInputs(updatedInputs);
  };

  const handleAddInput = () => {
    setRepoInputs([...repoInputs, { repoUrl: '', branch: '', username: '', password: '', relevantPath: '' }]);
  };

  const handleDeleteInput = (index) => {
    const updatedInputs = [...repoInputs];
    updatedInputs.splice(index, 1);
    setRepoInputs(updatedInputs);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handlePROk = () => {
    setIsPRModalVisible(false);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };
  
  
  const handleCopy = (code) => {
    navigator.clipboard.writeText(code).then(
      () => {
        toast.success("Code copied to clipboard!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      },
      (err) => {
        toast.error("Failed to copy code. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      }
    );
  };
  

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: ResponseJson,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };  

  const handleTypingStopped = () => {
    setIsTypingStopped(true);
    // Set the bot response
    setMessage((pv) => {
      const newFields = [...pv];
      if (
        newFields.length !== 0 &&
        typeof newFields[newFields.length - 1]["content"] == "object"
      ) {
        newFields[newFields.length - 1] = {
          ...newFields[newFields.length - 1],
          content: "The Response Has Been Canceled By User.",
        };
      }

      return newFields;
    });
  };
  // Accpets the feedback and enables the input field
  const handleFeedback = (value, botID) => {
    const updatedData = messages.map((item) => {
      if (item?.bot_id === botID) {
        return {
          ...item,
          feedbackAccepted: [...item["feedbackAccepted"], value],
        }; // Only update matching item
      }
      return item;
    });
    setMessage(updatedData);
  };

  // Accpets the typing completed value
  const handleTypingCompleted = (value) => {
    setMessage((pv) => {
      const newFields = [...pv];

      if (
        newFields.length !== 0 &&
        newFields[newFields.length - 1]["typingCompleted"] == null
      ) {
        newFields[newFields.length - 1] = {
          ...newFields[newFields.length - 1],
          typingCompleted: value,
        };
      }
      return newFields;
    });
    setIsTypingStopped(false);
  };


  const handleQuestionSubmitted = async (question) => {
    const newUuid = uuid();

    const formData = new FormData();
    formData.append("repositories", JSON.stringify(repoInputs));
    if (inputQuestion.trim() !== "") {
      formData.append("inputQuestion", inputQuestion.trim());
    }
    if (uploadedFile) {
      formData.append("inputFile", uploadedFile);
    }
    formData.append("prDetails", JSON.stringify(prDetails));


    setInputQuestion("");


    // Set the user question
    setMessage((pv) => [
      ...pv,
      {
        human_type: "user",
        content: (
          <>
            {inputQuestion.trim()}{" "}
          </>
        ),
      },
      {
        bot_id: newUuid,
        human_type: "bot",
        content: (
          <Row>
            <span className="chat-gr-text">Generating response</span>
            <Lottie options={defaultOptions} height={20} width={40} />
          </Row>
        ),
        typingCompleted: null,
      },
    ]);
    
    setIsChatting(true);
    
    // const response = await ChatModelFetch.submit_question({ question: question },{});
    let hasClearedContent = false;
    const { result } = await ChatModelFetch.code_genie(formData, (chunk) => {
      setMessage((prevMessages) => {
        const newMessages = [...prevMessages];
    
        // Find the last bot message
        const lastIndex = newMessages.length - 1;
        if (
          lastIndex >= 0 &&
          newMessages[lastIndex]["bot_id"] === newUuid
        ) {
          let previousContent = hasClearedContent
            ? (typeof newMessages[lastIndex].content === "object"
                ? newMessages[lastIndex].content.props.children || []
                : [newMessages[lastIndex].content])
            : [];
    
          hasClearedContent = true;
    
          // Concatenate new chunk correctly
          const updatedContent = [...previousContent, chunk].join("");

          const mermaidMatch = updatedContent.match(/```mermaid([\s\S]*?)```/);
          if (mermaidMatch) {
            setIsMermaidRendering(true);
            setTimeout(() => {
              mermaid.contentLoaded();
              setIsMermaidRendering(false);
              setMessage((msgs) => [...msgs]); // Force re-render
            }, 1000);
          }
    
          newMessages[lastIndex] = {
            ...newMessages[lastIndex],
            content: (
             <ReactMarkdown
      remarkPlugins={[remarkParse, remarkGfm]}
      components={{
        code({ node, inline, className, children, ...props }) {
          const match = /language-(\w+)/.exec(className || "");
          const codeString = String(children).replace(/\n$/, "");

          if (!inline && match?.[1] === "mermaid") {
            return isMermaidRendering ? (
              <div className="mermaid-loader">
                <Spin size="small" /> Rendering diagram...
              </div>
            ) : (
              <div className="mermaid">{codeString}</div>
            );
          }

          return !inline && match ? (
            <div style={{ position: "relative", marginBottom: "1rem", background: "#282c34", borderRadius: "8px", padding: "1rem" }}>
              <SyntaxHighlighter style={oneDark} language={match[1]} PreTag="div" {...props}>
                {codeString}
              </SyntaxHighlighter>
              <button
                onClick={() => handleCopy(codeString)}
                style={{
                  position: "absolute",
                  top: "8px",
                  right: "8px",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                }}
                title="Copy to clipboard"
              >
                <FaRegCopy size={16} />
              </button>
            </div>
          ) : (
            <code className={className} {...props}>
              {children}
            </code>
          );
        },
      }}
    >
      {updatedContent}
    </ReactMarkdown>


            ),
          };
        }
        return newMessages;
      });
    });
    
    // Optionally, set typingCompleted to true once done
    setMessage((pv) => {
      const newFields = [...pv];
      if (
        newFields.length !== 0 &&
        newFields[newFields.length - 1]["bot_id"] === newUuid && 
        (typeof newFields[newFields.length - 1]["content"] == "object" ||
        (typeof newFields[newFields.length - 1]["content"] == "string" &&
          newFields[newFields.length - 1]["content"] !== "" &&
          newFields[newFields.length - 1]["typingCompleted"] === false))
        ){
        newFields[newFields.length - 1] = {
          ...newFields[newFields.length - 1],
          typingCompleted: true, 
          // content : result,
          responseID: "1", // Add responseID after the stream ends,
          feedbackAccepted: [],
        };
      }
  
      return newFields;
    });
  };

  const handleClearAll = async () => {
    setIsChatting(false);
    setInputQuestion("");
    setMessage([]);
    setIsTypingStopped(false);
  };


  return (
    <Row className="background-container">
      <BuzzBucketHeader handleClearAll={handleClearAll} />
      {!isChatting ? (
        <BuzzBucketHomePage handleQuestionSubmitted={handleQuestionSubmitted} />
      ) : (
        <ChatWindow 
          chat_messages={messages}
          typingStopped={isTypingStopped}
          handleFeedback={handleFeedback}
          handleTypingCompleted={handleTypingCompleted}
        />
      )}

      <Row className="chat-input-section" align="bottom" justify="center">
        <Col>
          <div style={{ display: 'flex', gap: '10px', marginTop: '10px', marginBottom: '10px', justifyContent: 'center' }}>
            <Button onClick={showModal} icon={<GithubOutlined />} disabled={isPRDetailsEntered || isFileUploaded || disableUpload}>Add Repo</Button>
            <Upload {...uploadProps} disabled={isPRDetailsEntered || isGitDetailsEntered || disableUpload} maxCount={1}>
              <Button 
                icon={<UploadOutlined />} 
                style={{
                  backgroundColor: isPRDetailsEntered || isGitDetailsEntered || disableUpload ? '#e6e6e6' : '', // Set disabled background color
                  borderColor: isPRDetailsEntered || isGitDetailsEntered || disableUpload ? '#e6e6e6' : '', // Set disabled border color
                  color: isPRDetailsEntered || isGitDetailsEntered || disableUpload ? '#8f93a8' : '', // Set disabled text color
                }}
              >
                Upload File
              </Button>
            </Upload>

            <Button onClick={() => setIsPRModalVisible(true)} icon={<PlusOutlined />} disabled={isFileUploaded || isGitDetailsEntered || disableUpload}>Add PR Link</Button>
          </div>

          <div className="box" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <TextArea
                className="input-chat-box"
                style={{
                  width: '52rem',
                  height: '3.5rem',
                  border: 'none',
                  padding: '10px',
                  borderRadius: '8px',
                  backgroundColor: 'white',
                  color: '#2a2a2a',
                  fontSize: '18px',
                  lineHeight: '23.44px',
                  boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                }}
                placeholder="Ask your question..."
                autoSize={{ minRows: 1, maxRows: 5 }}
                value={inputQuestion}
                onChange={(e) => setInputQuestion(e.target.value)}
                disabled={!isGitDetailsEntered && !isPRDetailsEntered && !isFileUploaded}
              />
            <Button 
              disabled={!inputQuestion} 
              className="chat-submit-button" 
              onClick={() => handleQuestionSubmitted(inputQuestion)}
            >
              <ArrowRightOutlined />
            </Button>
          </div>

          <Row className="chat-input-lower-div">
            <Text className="chat-input-beta-text">BuzzBucket is in Beta version.</Text>
            <Button disabled={!isChatting} type="link" className="chat-input-clear-all" onClick={handleClearAll}>Clear All</Button>
          </Row>
        </Col>
      </Row>

      <Modal title="Add Repository" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
        {repoInputs.map((input, index) => (
          <div key={index} style={{ marginBottom: 16 }}>
            <Input placeholder="Repository URL" value={input.repoUrl} onChange={(e) => handleInputChange(index, 'repoUrl', e.target.value)} />
            <Input placeholder="Branch" value={input.branch} onChange={(e) => handleInputChange(index, 'branch', e.target.value)} />
            <Input placeholder="Username" value={input.username} onChange={(e) => handleInputChange(index, 'username', e.target.value)} />
            <Input.Password placeholder="Password" value={input.password} onChange={(e) => handleInputChange(index, 'password', e.target.value)} />
            <Input placeholder="Relevant Path" value={input.relevantPath} onChange={(e) => handleInputChange(index, 'relevantPath', e.target.value)} />
            <Button icon={<DeleteOutlined />} onClick={() => handleDeleteInput(index)}>Delete</Button>
          </div>
        ))}
        <Button onClick={handleAddInput}>Add Another Repository</Button>
      </Modal>

      <Modal title="Add PR Link" visible={isPRModalVisible} onOk={handlePROk} onCancel={() => setIsPRModalVisible(false)}>
        <Input placeholder="PR Link" value={prDetails.prLink} onChange={(e) => setPRDetails({ ...prDetails, prLink: e.target.value })} />
        <Input placeholder="Username" value={prDetails.username} onChange={(e) => setPRDetails({ ...prDetails, username: e.target.value })} />
        <Input.Password placeholder="Password" value={prDetails.password} onChange={(e) => setPRDetails({ ...prDetails, password: e.target.value })} />
      </Modal>
    </Row>
  );

};
